import { RSAA } from 'redux-api-middleware'
import { getApiPath, makeQueryParams } from 'sidecar-utility-library'
import { makeApiTypes } from 'sidecar-utility-library'

export const types = {
  ...makeApiTypes('FETCH_POINT_SOLUTIONS', 'pointSolutions'),
  CLEAR_POINT_SOLUTIONS: 'CLEAR_POINT_SOLUTIONS',
  ...makeApiTypes(
    'FETCH_MEMBER_COMMS_POINT_SOLUTIONS',
    'memberCommsPointSolutions',
  ),
  CLEAR_MEMBER_COMMS_POINT_SOLUTIONS: 'CLEAR_MEMBER_COMMS_POINT_SOLUTIONS',
}

export const initialState = {
  pointSolutions: {
    busy: false,
    error: '',
    entities: [],
  },
  memberCommsPointSolutions: {
    busy: false,
    error: '',
    entities: [],
  },
}

export const fetchPointSolutions = ({
  insuranceFilingUuid, // required
  category, // string comma separated list of categories
  parentBundleCode, // string parent bundle code
  // if both category and parentBundleCode are provided, endpoint will return an error
}) => ({
  [RSAA]: {
    endpoint: () => {
      const params = {
        insuranceFilingUuid,
        ...(category && { category }),
        ...(parentBundleCode && { parentBundleCode }),
      }

      const queryString = makeQueryParams(params)
      return getApiPath('care', `pointSolutions${queryString}`)
    },
    method: 'GET',
    types: [
      types.FETCH_POINT_SOLUTIONS_REQUEST,
      types.FETCH_POINT_SOLUTIONS_SUCCESS,
      types.FETCH_POINT_SOLUTIONS_ERROR,
    ],
  },
})

export const clearPointSolutions = () => ({
  type: types.CLEAR_POINT_SOLUTIONS,
})

export const fetchMemberCommsPointSolutions = ({
  insuranceFilingUuid, // required
  category, // string comma separated list of categories
  parentBundleCode, // string parent bundle code
  // if both category and parentBundleCode are provided, endpoint will return an error
}) => ({
  [RSAA]: {
    endpoint: () => {
      const params = {
        insuranceFilingUuid,
        ...(category && { category }),
        ...(parentBundleCode && { parentBundleCode }),
      }

      const queryString = makeQueryParams(params)
      return getApiPath('care', `pointSolutions${queryString}`)
    },
    method: 'GET',
    types: [
      types.FETCH_MEMBER_COMMS_POINT_SOLUTIONS_REQUEST,
      types.FETCH_MEMBER_COMMS_POINT_SOLUTIONS_SUCCESS,
      types.FETCH_MEMBER_COMMS_POINT_SOLUTIONS_ERROR,
    ],
  },
})

export const clearMemberCommsPointSolutions = () => ({
  type: types.CLEAR_MEMBER_COMMS_POINT_SOLUTIONS,
})

const PointSolutionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_POINT_SOLUTIONS_REQUEST:
      return {
        ...state,
        pointSolutions: {
          ...state.pointSolutions,
          busy: true,
          error: '',
        },
      }

    case types.FETCH_POINT_SOLUTIONS_SUCCESS:
      return {
        ...state,
        pointSolutions: {
          ...state.pointSolutions,
          busy: false,
          error: '',
          entities: action.payload.pointSolutions || [],
        },
      }

    case types.FETCH_POINT_SOLUTIONS_ERROR:
      return {
        ...state,
        pointSolutions: {
          ...state.pointSolutions,
          busy: false,
          error: action.payload?.message || 'Failed to fetch point solutions',
          entities: [],
        },
      }

    case types.CLEAR_POINT_SOLUTIONS:
      return {
        ...state,
        pointSolutions: initialState.pointSolutions,
      }

    case types.FETCH_MEMBER_COMMS_POINT_SOLUTIONS_REQUEST:
      return {
        ...state,
        memberCommsPointSolutions: {
          ...state.memberCommsPointSolutions,
          busy: true,
          error: '',
        },
      }

    case types.FETCH_MEMBER_COMMS_POINT_SOLUTIONS_SUCCESS:
      return {
        ...state,
        memberCommsPointSolutions: {
          ...state.memberCommsPointSolutions,
          busy: false,
          error: '',
          entities: action.payload.pointSolutions || [],
        },
      }

    case types.FETCH_MEMBER_COMMS_POINT_SOLUTIONS_ERROR:
      return {
        ...state,
        memberCommsPointSolutions: {
          ...state.memberCommsPointSolutions,
          busy: false,
          error: action.payload?.message || 'Failed to fetch point solutions',
          entities: [],
        },
      }

    case types.CLEAR_MEMBER_COMMS_POINT_SOLUTIONS:
      return {
        ...state,
        memberCommsPointSolutions: initialState.memberCommsPointSolutions,
      }

    default:
      return state
  }
}

export default PointSolutionsReducer
